import React from "react";
import { Check } from "lucide-react";

export const STEP_LABELS = ["Getting started", "About you", "Where you've lived", "Court info & consent", "Review & submit"];

export default function Stepper({ step, labels: STEP_LABELS }: { step: number; labels: string[] }) {
  const pct = Math.round((step / (STEP_LABELS.length - 1)) * 100);
  return (
    <div data-testid="wizard-step-progress-indicator" className="sticky top-20 z-40 mb-8 rounded-2xl border border-slate-200 bg-white/95 px-5 py-4 shadow-sm backdrop-blur">
      <div className="flex items-center justify-between gap-2">
        {STEP_LABELS.map((l, i) => {
          const done = i < step;
          const active = i === step;
          return (
            <div key={l} className="flex flex-1 items-center gap-2 last:flex-none">
              <span
                data-testid={`wizard-step-${i}`}
                className={`grid h-9 w-9 shrink-0 place-items-center rounded-full text-sm font-bold transition-colors duration-300 ${
                  done ? "bg-[#14B8A6] text-white" : active ? "bg-[#F26B4F] text-white ring-4 ring-[#F26B4F]/25" : "bg-[#FFF1E8] text-[#E8A08E]"
                }`}
              >
                {done ? <Check className="h-4 w-4" /> : i + 1}
              </span>
              <span className={`hidden text-sm font-semibold md:block ${active ? "text-[#1A2536]" : "text-[#94A3B8]"}`}>{l}</span>
              {i < STEP_LABELS.length - 1 && <span className={`mx-1 h-0.5 flex-1 rounded ${done ? "bg-[#14B8A6]" : "bg-[#FBE3D8]"}`} />}
            </div>
          );
        })}
      </div>
      <p className="mt-3 text-sm text-[#64748B] md:hidden">
        Step {step + 1} of {STEP_LABELS.length}: <span className="font-semibold text-[#1A2536]">{STEP_LABELS[step]}</span> · {pct}%
      </p>
    </div>
  );
}
